// extracted by mini-css-extract-plugin
module.exports = {"snackbar_container":"SnackbarContainer_snackbar_container__2f1T7"};